.root {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
